import Nullstack from 'nullstack';
export default function IconBat({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bat",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 16c.74 -2.286 2.778 -3.762 5 -3c-.173 -2.595 .13 -5.314 -2 -7.5c-1.708 2.648 -3.358 2.557 -5 2.5v-4l-3 2l-3 -2v4c-1.642 .057 -3.292 .148 -5 -2.5c-2.13 2.186 -1.827 4.905 -2 7.5c2.222 -.762 4.26 .714 5 3c2.593 0 3.889 .952 5 4c1.111 -3.048 2.407 -4 5 -4z"
  }), "   ", Nullstack.element("path", {
    d: "M9 8a3 3 0 0 0 6 0"
  }), " ");
}